import validator from 'validator';

const validate = (fieldName, value = null) => {
  let errors = null;

  if (value) {
    // Email validation
    if (fieldName === 'email') {
      if (!validator.isEmail(value) || /\s/.test(value)) {
        errors = {};
        errors[fieldName] = 'Please enter a valid email address';
      }
    }
  }

  return errors;
};

export default validate;
